module.exports = __webpack_public_path__ + "img/project-selected.e5d6d3f5.png";